import {HttpClient, HttpClientModule} from "@angular/common/http";
import { NgModule, APP_INITIALIZER } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouteReuseStrategy } from "@angular/router";
import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { AppRoutingModule } from "./app-routing.module";
import { SharedModule } from "./components/shared.module";
import { AppComponent } from "./app.component";
import { RestolutionService } from "./services/restolution";
import { RxStompService } from "@stomp/ng2-stompjs";
import { BestoranteService } from "./services/bestorante";
import { UtilsService } from "./services/utils";
import { ConfigurationService } from "./services/configuration";
import { SoftposService } from "./services/softpos";
import { ReceiptStore } from "./services/receiptstore";
import { UiThemeService } from "./services/ui-theme.service";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {TranslatePoHttpLoader} from "./services/translatePoHttpLoader";
import { IonicStorageModule } from "@ionic/storage-angular";
import { ScreenOrientation } from "@ionic-native/screen-orientation/ngx";
import { ScreenOrientationService } from "./services/screen-orientation.service";
import { Drivers } from "@ionic/storage";
import * as CordovaSQLiteDriver from "localforage-cordovasqlitedriver";
import {CardPaymentService} from "./services/cardpayment.service";

import {CardPaymentServiceNets} from "./services/cardpayment.service.nets";
import { DateService } from "./services/date.service";
import {PrintService} from "./services/print.service";
import {PrintServiceNets} from "./services/print.service.nets";
import {CardPaymentAndPrintServicePoplatek} from "./services/cardpayment.service.poplatek";
import { GuestModeService } from "./services/guest-mode.service";
import { LoggingService } from "ionic-logging-service";
import { environment } from "../environments/environment.prod";
import { LoggingViewerModule } from "ionic-logging-viewer";

export const createTranslateLoader = (http: HttpClient) => new TranslatePoHttpLoader(http, "assets/i18n", ".po");

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function configureLogging(loggingService: LoggingService): () => void {
	return () => loggingService.configure(environment.logging);
}

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    IonicStorageModule.forRoot({
      name: "__bestogodb",
      // eslint-disable-next-line no-underscore-dangle
      driverOrder: [CordovaSQLiteDriver._driver, Drivers.IndexedDB, Drivers.LocalStorage]
    }),
    AppRoutingModule,
    SharedModule,
    LoggingViewerModule,
    HttpClientModule,
    TranslateModule.forRoot({
      defaultLanguage: "en",
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    RestolutionService,
    BestoranteService,
    UtilsService,
    ConfigurationService,
    SoftposService,
    CardPaymentService,
    CardPaymentServiceNets,
    CardPaymentAndPrintServicePoplatek,
    PrintService,
    PrintServiceNets,
    UiThemeService,
    ReceiptStore,
    ScreenOrientation,
    ScreenOrientationService,
    DateService,
    GuestModeService,
    {
      provide: "remoteStomp",
      useClass: RxStompService,
    },
    {
      deps: [LoggingService],
      multi: true,
      provide: APP_INITIALIZER,
      useFactory: configureLogging,
  }
  ],
  bootstrap: [AppComponent],
  exports: [],
})
export class AppModule {}
